import { render, staticRenderFns } from "./AuroraBody.vue?vue&type=template&id=70da9d74"
import script from "./AuroraBody.vue?vue&type=script&lang=js"
export * from "./AuroraBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports